// Configuration file for API URLs and other constants

// Auto-detect backend URL based on environment
const getBackendUrl = (): string => {
  // 1. Check if VITE_BACKEND_API_URL is explicitly set (production build)
  if ((import.meta as any).env?.VITE_BACKEND_API_URL) {
    const url = (import.meta as any).env.VITE_BACKEND_API_URL
    if ((import.meta as any).env?.DEV) {
      console.log('🔧 [Config] Using VITE_BACKEND_API_URL:', url)
    }
    return url
  }
  
  // 2. Check if running in development (localhost)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    const url = 'http://localhost:8000/api/v1'
    if ((import.meta as any).env?.DEV) {
      console.log('🔧 [Config] Using localhost URL:', url)
    }
    return url
  }
  
  // 3. Auto-detect based on current hostname (production)
  // If accessing via IP, use the same IP for backend
  const protocol = window.location.protocol
  const hostname = window.location.hostname
  const port = '8000' // Backend port
  const url = `${protocol}//${hostname}:${port}/api/v1`
  
  // Log in development to help debug
  if ((import.meta as any).env?.DEV) {
    console.log('🔧 [Config] Auto-detected URL:', url, {
      protocol,
      hostname,
      port,
      currentUrl: window.location.href
    })
  }
  
  return url
}

export const config = {
  // API Configuration - Auto-detected based on environment
  API_BASE_URL: getBackendUrl(),
  
  // App Configuration
  APP_NAME: (import.meta as any).env?.VITE_APP_NAME || 'Lognex Insight',
  APP_VERSION: (import.meta as any).env?.VITE_APP_VERSION || '1.0.0',
  
  // API Endpoints
  ENDPOINTS: {
    DASHBOARD: '/dashboard/overview',
    SALES_FORCE_ANALYSIS: '/sales-force/analysis',
    CTES: '/ctes',
    NFES: '/nfes',
    CLIENTS: '/clients',
    DISTRIBUTION_CENTERS: '/distribution-centers',
    COSTS: '/costs',
    LOGISTICS: '/logistics'
  }
} as const

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${config.API_BASE_URL}${endpoint}`
}

// Helper function to get environment variable with fallback
export const getEnvVar = (key: string, fallback: string = ''): string => {
  return (import.meta as any).env?.[key] || fallback
}
